import React from 'react';
import { ComingSoon } from './pages/ComingSoon';
interface AppProps {
  /** Coordinated accent that repaints the orb, the mark, and the status dot. */
  accent?: 'violet' | 'teal' | 'ember';
  /** How much of the viewport the background orb occupies (vmax). */
  orbScale?: number;
}
export function App({
  accent = 'violet',
  orbScale = 78
}: AppProps) {
  return <ComingSoon accent={accent} orbScale={orbScale} data-id="element-0" data-mp="3f8f2ntzjabyy" />;
}